import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';

const styles = 'bg-gray-50 px-3 py-4 text-left text-sm font-semibold';

const TableHead: React.FC = () => {
  return (
    <>
      <th className={styles}>
        <T kind="Title" />
      </th>
      <th className={styles}>
        <T kind="Competencies" />
      </th>
      <th className={styles}>
        <T kind="Program Type" />
      </th>
      <th className={styles}>
        <T kind="Start Dates" />
      </th>
      <th className={styles}>
        <T kind="Partner" />
      </th>
      <th className={styles}>
        <T kind="Description" />
      </th>
    </>
  );
};

export default observer(TableHead);
